<template>
  <div class="send-sms">
    <Modal v-model="show" :title="title" :footer-hide="true">
      <div class="main">
        <slot name="header"></slot>
        <p style="padding-top: 8px">
          请输入{{ phoneNo | fliterPhone }}收到的验证码，进行确证操作。
        </p>
        <div class="input-main">
          <Input
            v-model="phoneCode"
            placeholder="请输入短信验证码"
            style="width: 300px"
          />
          <p class="msg-text" @click="handleSend">{{ msgText }}</p>
        </div>
        <p class="msg-error">{{ errorStr }}</p>
      </div>
      <div class="modal-430-bottom">
        <Button @click="handleCancle">取消</Button>
        <Button type="primary" @click="handleSubmit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import common from '@/request/common/index';
import financeCenterApi from '@/request/financeCenter/index.js';
import { fliterPhone } from '@/utils/utils';
export default {
  name: "SendSmsForMerchants", //  关联资管平台的商户管理员的手机号码 
  data() {
    return {

      show: false,
      phoneCode: '',
      errorStr: '',
      msgText: '获取验证码',
      timer: null,
      credential: ''
    }
  },
  props: {
    title: {
      type: String,
      default: "验证短信验证码"
    },
    phoneNo: {
      type: String, // 关联资管平台的商户管理员的手机号码
      default: ""
    },
    sheetId: {
      type: String, // 
      default: ""
    }
  },
  created() {

  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    handleShow() {
      this.show = true
      this.phoneCode = ''
      this.errorStr = ''
      this.credential = ''
      this.msgText = '获取验证码'
      this.timer && clearInterval(this.timer);

    },
    handleHide() {
      this.show = false
    },

    async handleSend() {
      if (this.msgText != '获取验证码') {
        return null;
      }
      let res = await financeCenterApi.sendMsgApi({
        sheetId: this.sheetId,
        phone: this.phoneNo,
      })

      if (res.status == 200) {
        this.credential = res.message
        let second = 60;
        this.msgText = `${second}s后获取`;
        this.timer = setInterval(() => {
          if (second == 0) {
            clearInterval(this.timer);
            this.msgText = "获取验证码";
            return false;
          }
          second--;
          this.msgText = `${second}s后获取`;
        }, 1000);
      }

    },
    handleCancle() {
      this.show = false
    },
    handleSubmit() {
      if (!this.phoneCode) {
        return this.$Message.warning('请输入短信验证码');
      }
      this.$emit('on-finish', {
        credential: this.credential,
        phoneCode: this.phoneCode
      })
    },

  },
  filters: {
    fliterPhone(phone) {
      if (phone) {
        return fliterPhone(phone);
      } else {
        return '--';
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.input-main {
  padding: 16px 0;
  position: relative;
  width: 300px;
  .msg-text {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #6149f1;
    cursor: pointer;
  }
}
.msg-error {
  color: red;
}
</style>